var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMailingAddress = function SvgMailingAddress(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    id: "mailing-address_svg__Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".mailing-address_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5.6h10c.6 0 1 .4 1 1v6c0 .6-.4 1-1 1H7c-.6 0-1-.4-1-1v-6c0-.6.4-1 1-1",
    className: "mailing-address_svg__st0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m8 7.6 4 2.5 4-2.5",
    className: "mailing-address_svg__st0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12 .6c2.2 0 4.3.6 6.1 1.8 4.8 3 5.1 9.2 1.3 13.8-2.2 2.6-4.5 5-7.1 7.2-.2.2-.5.2-.6 0-2.6-2.2-4.9-4.6-7.1-7.2C.8 11.6 1.1 5.4 5.9 2.3 7.7 1.2 9.8.6 12 .6",
    className: "mailing-address_svg__st0"
  })));
};
export default SvgMailingAddress;